import { controlRoutes } from '../../routes/controlRoutes';
import { getTestRoutes } from '../../routes/testRoutes';
import { additionalRoutes } from '../../routes/additionalRoutes';
import { ClientRoute } from '../../models/router/clientRoute';
import { isLandingPageJourney } from '../posthog/isLandingPageJourney';

/**
 * @description
 * This file is responsible for defining the routes for the application.
 * It should export a function that returns an array of route objects.
 * Each route object should have a `path` and a `component` property.
 */
export const getRoutes = (
  clientRoutes: ClientRoute[] | undefined = [],
  landingHeroPath: string = '',
  landingBrandPath: string = '',
  environment?: string,
): {
  formStepRoutes: ClientRoute[];
  additionalRoutes: ClientRoute[];
} => {
  const landingPageFlagEnabled = isLandingPageJourney();
  return {
    formStepRoutes: landingPageFlagEnabled
      ? getTestRoutes(landingHeroPath, landingBrandPath, environment)
      : controlRoutes,
    additionalRoutes: [...additionalRoutes, ...clientRoutes],
  };
};
